import { createAction } from 'typesafe-actions';

import { DownloadFileResponse } from './types';

export const downloadFile = createAction('downloadFile/DOWNLOAD_FILE')<DownloadFileResponse>();
